import { makeStyles } from '@material-ui/core';
import { ISpcTheme } from '../../../../../../common/theme/ISpcTheme';

export type SingleCurrencyCashClasses = 'priceLabel' | 'price';

const singleCurrencyCashStyles = makeStyles<ISpcTheme, SingleCurrencyCashClasses>(
  theme => ({
    priceLabel: {
      fontSize: theme.typography.fontXS,
    },
    price: {
      paddingLeft: '20px',
      [theme.breakpoints.down('xs')]: {
        paddingLeft: '5px',
      },
    },
  }),
  { name: 'Customise_SingleCurrencyCash' },
);

export default singleCurrencyCashStyles;
